import { FormControl, FormGroup } from "@angular/forms";
import { createLandAreaFormGroup, LandAreaFormGroup } from "../land-areas/form-group";

export type ParcelIdentificationFormGroup = FormGroup<{
  add_info_on_land: FormControl<boolean>,
  land_parcel_name: FormControl<string>,
  boundary_type: FormControl<number>,
  coordinate_reference_system_id: FormControl<number>,
  land_area: LandAreaFormGroup
}>

export function createParcelIdentificationFormGroup(payload: {
  addInfoOnLand: boolean,
  landParcelName: string,
  boundaryType: number,
  coordinateReferenceSystemId: number
  landArea: {
    planningStatusId: number,
    qosDegradationId: number,
    envConsiderations: string,
    otherConsiderations: string
  }
}): ParcelIdentificationFormGroup {
  return new FormGroup({
    add_info_on_land: new FormControl<boolean>(payload.addInfoOnLand),
    land_parcel_name: new FormControl<string>(payload.landParcelName),
    boundary_type: new FormControl<number>(payload.boundaryType),
    coordinate_reference_system_id: new FormControl<number>(payload.coordinateReferenceSystemId),
    land_area: createLandAreaFormGroup(payload.landArea)
  })
}